import useHttp from 'helpers/HttpMethods';
import { ServiceGroupSummary } from 'types/ServiceGroupTypes';

const http = useHttp();
class AgentServiceGroupService {
  /**
   * List service groups for a specific agent.
   * @param {number} agentId - ID of the agent.
   * @returns {Promise<any>} - Returns a promise that resolves to the list of service groups.
   */
  static async list(agentId: number): Promise<ServiceGroupSummary[]> {
    return await http.get(`/agents/${agentId}/service-groups`);
  }
}

export default AgentServiceGroupService;
